export const DEFAULT_CANCEL_LINGER_MS = 8000;
export const HEAVY_VEHICLE_CANCEL_LINGER_MS = 60_000;

// Truck-class orders sit in Pending for 15 minutes before a system cancel and are rarely
// re-created, so operators need longer to notice the red row before it disappears.
const HEAVY_VEHICLE_TARIFF_PREFIXES = [
  'ggtruck',
  'ggevacuator',
  'ggevakuator',
  'ggmanipulator',
  'gglift',
  'ggvishka'
];

export function cancelLingerMsForTariffName(tariffName: string | null | undefined): number {
  const name = (tariffName ?? '').trim().toLowerCase();

  return HEAVY_VEHICLE_TARIFF_PREFIXES.some((prefix) => name.startsWith(prefix))
    ? HEAVY_VEHICLE_CANCEL_LINGER_MS
    : DEFAULT_CANCEL_LINGER_MS;
}
